import { useDroppable } from '@dnd-kit/core';

export default function GroupDropSlot({ index }) {
  const { setNodeRef, isOver } = useDroppable({
    id: `group-slot:${index}`,
    data: { type: 'groupSlot', index },
  });
  return (
    <div
      ref={setNodeRef}
      className="relative h-2 -my-1 flex items-center"
    >
      <div
        className={`w-full transition-all rounded-full ${
          isOver ? 'h-1.5 bg-accent' : 'h-0.5 bg-accent/20'
        }`}
      />
    </div>
  );
}
